import axios from 'axios';
import store from '../store/index';

let customHeaders = {};

if(store.state.authUser && store.state.authUser.token) {
    customHeaders = {Authorization: `Bearer ${store.state.authUser.token}`};
}

const client = axios.create({
    timeout: 12000,
    baseURL: 'https://us-central1-jaiminhobot.cloudfunctions.net/',
    headers: {
        ...customHeaders
    },
});

// interceptor to add token
// client.interceptors.request.use((config) => {
//     let token = localStorage.getItem('token_auth');
//     if(!token) return config;
//     token = atob(token);
//     config.headers.Authorization = `Token ${token}`;
//     return config;
// });

export default client;